document.querySelectorAll(".copythecode").forEach(function (copyDiv) {
  copyDiv.addEventListener("click", function () {
    // Find the span with class "code" inside the clicked div
    var codeText = copyDiv.querySelector(".code").innerText;

    // Create a temporary input element to hold the text
    var tempInput = document.createElement("input");
    tempInput.value = codeText;

    // Add the input to the body, select the text, and copy it
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");

    // Remove the temporary input
    document.body.removeChild(tempInput);

    // Optionally, you can show a confirmation message
    alert("Code copied to clipboard!");
  });
});
